import ApiService from '../service/http.js'
import OSS from "ali-oss";


const timeFormate = (timestamp, style) => {
    if (String(timestamp).length < 13) {
        timestamp *= 1000
    }
    // 首先判定sytle的格式
    let date = new Date(timestamp)
    let year = date.getFullYear()
    let month = (date.getMonth() + 1).toString().padStart(2, 0)
    let weekText = ['日', '一', '二', '三', '四', '五', '六']

    let week = '周' + weekText[date.getDay()]

    let day = date
        .getDate()
        .toString()
        .padStart(2, 0)
    let hour = date
        .getHours()
        .toString()
        .padStart(2, 0)
    let minute = date
        .getMinutes()
        .toString()
        .padStart(2, 0)
    let seconds = date
        .getSeconds()
        .toString()
        .padStart(2, 0)
    return style
        .replace('YYYY', year)
        .replace('YY', String(year).substr(String(year).length - 2))
        .replace('MM', month)
        .replace('DD', day)
        .replace('WW', week)
        .replace('HH', hour)
        .replace('mm', minute)
        .replace('ss', seconds)
}
const resolveBlob = (res, mimeType, filename)=> {
  const aLink = document.createElement('a')
  var blob = new Blob([res.data], { type: mimeType })
  // //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
  var patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
  var contentDisposition = decodeURI(res.headers['content-disposition'])
  var result = patt.exec(contentDisposition)
  var fileName
  if(filename) {
    fileName = filename
  } else {
    fileName = result[1]
    fileName = fileName.replace(/\"/g, '')
  }
  aLink.href = URL.createObjectURL(blob)
  aLink.setAttribute('download', fileName) // 设置下载文件名称
  document.body.appendChild(aLink)
  aLink.click()

  document.body.appendChild(aLink)
}
const urlDownload = (url,fileName,extension)=> {
  let extensionStr = extension.toLowerCase()
  if('jpg|jpeg|png|gif|txt|css|scss|js|pdf|md|mp4|avi|wmv|mpg|mpeg|mov|rm|ram|swf|flv'.indexOf(extensionStr)>-1){
    fetch(url).then((response) => response.blob()).then((res) => {
      let blod = new Blob([res]);
      const href = window.URL.createObjectURL(blod); //创建下载的链接
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blod, fileName);
      } else {
        // 谷歌浏览器 创建a标签 添加download属性下载
        const alink = document.createElement("a");
        alink.href = href;
        alink.target = "_blank";
        alink.download = fileName;
        document.body.appendChild(alink);
        alink.click(); // 点击下载
        window.URL.revokeObjectURL(href); // 释放掉blob对象
        document.body.removeChild(alink); // 下载完成移除元素
      }
    });
  }else{
    window.open(url,'_blank')
  }
}
const formatFileSize = (fileSize)=>{
  if (fileSize < 1024) {
    return fileSize + 'B';
  } else if (fileSize < (1024*1024)) {
    var temp = fileSize / 1024;
    temp = temp.toFixed(2);
    return temp + 'KB';
  } else if (fileSize < (1024*1024*1024)) {
    var temp = fileSize / (1024*1024);
    temp = temp.toFixed(2);
    return temp + 'MB';
  } else {
    var temp = fileSize / (1024*1024*1024);
    temp = temp.toFixed(2);
    return temp + 'GB';
  }
}
const formatFileSuffix = (fileSuffix)=>{
  let str = ''
  if('JPG|JPEG|PNG|GIF'.indexOf(fileSuffix)>-1){
    str = '<svg class="icon svg-icon myCustomFileIcon" aria-hidden="true" style="font-size: 15px;"><use xlink:href="#yjk-icon-img"></use></svg>'
  }else if('DOCX|DOC'.indexOf(fileSuffix)>-1){
    str = '<svg class="icon svg-icon myCustomFileIcon" aria-hidden="true"><use xlink:href="#yjk-icon-docx"></use></svg>'
  }else if('DWG'.indexOf(fileSuffix)>-1){
    str = '<svg class="icon svg-icon myCustomFileIcon" aria-hidden="true"><use xlink:href="#yjk-icon-dwg"></use></svg>'
  }else if('XLS|XLSX'.indexOf(fileSuffix)>-1){
    str = '<svg class="icon svg-icon myCustomFileIcon" aria-hidden="true"><use xlink:href="#yjk-icon-exciel"></use></svg>'
  }else if('PPT|PPTX'.indexOf(fileSuffix)>-1){
    str = '<svg class="icon svg-icon myCustomFileIcon" aria-hidden="true"><use xlink:href="#yjk-icon-ppt"></use></svg>'
  }else if('AVI|WMV|MPG|MPEG|MOV|RM|RAM|SWF|FLV|MP4'.indexOf(fileSuffix)>-1){
    str = '<svg class="icon svg-icon myCustomFileIcon" aria-hidden="true"><use xlink:href="#yjk-icon-mp4"></use></svg>'
  }else if('FOLDER'.indexOf(fileSuffix)>-1){
    str = '<svg class="icon svg-icon myCustomFileIcon" aria-hidden="true"><use xlink:href="#yjk-a-icon-wenjianjiawujianbian"></use></svg>'
  }else if('TXT'.indexOf(fileSuffix)>-1){
    str = '<svg class="icon svg-icon myCustomFileIcon" aria-hidden="true"><use xlink:href="#yjk-icon-txt"></use></svg>'
  }else if('AIFF|AU|MIDI|WAV|RA|SWA|WMA|QT|MP3'.indexOf(fileSuffix)>-1){
    str = '<svg class="icon svg-icon myCustomFileIcon" aria-hidden="true"><use xlink:href="#yjk-icon-mp3"></use></svg>'
  }else if('PDF'.indexOf(fileSuffix)>-1){
    str = '<svg class="icon svg-icon myCustomFileIcon" aria-hidden="true"><use xlink:href="#yjk-icon-pdf"></use></svg>'
  }else if('RAR|ZIP'.indexOf(fileSuffix)>-1){
    str = '<svg class="icon svg-icon myCustomFileIcon" aria-hidden="true"><use xlink:href="#yjk-a-icon-rarwujianbian"></use></svg>'
  }else{
    str = '<svg class="icon svg-icon myCustomFileIcon" aria-hidden="true"><use xlink:href="#yjk-a-icon-zonghewenjianwujianbian"></use></svg>'
  }
  return str
}

const createUUid = (len, radix)=> {   //指定长度和基数 例如：uuid2(16, 16)
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  var uuid = [], i;
  radix = radix || chars.length;
  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
  } else {
    // rfc4122, version 4 form
    var r;
    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';
    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16;
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join('');
}

const getAliFileUrl = (name,fullName,type)=>{
  //type:1、预览链接，2、下载链接 ，url使用说明：window.open下载 或者 a标签下载；至于预览，浏览器支持的就会新窗口进行预览，不支持的就会走下载
  let http = new ApiService()
  let fileUrl = ''
  const cc = async ()=>{
    const res = await http.getStsToken({}, "get")
    if(res.code==='0'){
      var client = new OSS({
        region: 'oss-cn-beijing',
        accessKeyId: res.data.accessKeyId,
        accessKeySecret: res.data.accessKeySecret,
        stsToken:res.data.securityToken,
        bucket: res.data.bucket,
      });
      const response = {
        'content-disposition': `attachment; filename=${encodeURIComponent(name)}`
      }
      if(type===1){ //预览链接
        fileUrl = client.signatureUrl(fullName)
      }else if(type===2){ //下载链接
        fileUrl = client.signatureUrl(fullName, { response });
      }
      return fileUrl
    }
  }
  return cc()
}
export { timeFormate, resolveBlob,urlDownload, formatFileSize, formatFileSuffix, getAliFileUrl, createUUid, }
